"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var mySummaryExpandedCtaStyles = styles_1.makeStyles(function (theme) { return ({
    myAccountButtonContainer: {
        flexGrow: 1,
        margin: theme.spacing(2) + " 0 " + theme.spacing(4) + " 0",
    },
}); }, { name: 'GqlCheckout_ConfirmationMySummaryExpandedCta' });
exports.default = mySummaryExpandedCtaStyles;
